
import {getQueryParams, setQueryParam, stripURLHost} from "../../common/url";
import {createAjaxRequest, ajaxIsBusy} from "../../common/ajax";
import {CA_stringTrim} from "../../common/strings";
import {forceLogoutFromAjaxLogoff} from "../../common/login";

/**
 Polls the current URL for an ajax state value.
 Used for AJAX-refresh of most of our pages.

 Used to be a function (named checkSystemState2) but now an object with tweakable parameters.
 */
export function PageStateChecker() {
    /**
     The URL to poll with.  Defaults to document.location with the &ajax query parameter added on.
     */
    this.pollURL = null;

    /**
     The URL to load if a change is detected.  Default is document.location.
     */
    this.reloadURL = null;

    /**
     Polling frequency in seconds.  Defaults to global ajax timeout.
     */
    this.ajaxUpdateSec = GlobalEnt.pageData.ajaxUpdateSec || 5;

    /**
     Stop polling and log off if no changes for this many minutes.
     30min is typical Tomcat session timeout.
     */
    this.idleTimeInSecUntilUserIsLoggedOff = GlobalEnt.pageData.idleTimeInSecUntilUserIsLoggedOff || 1800;

    /**
     Your page can use this hook to read extra info from the response (eg headers).
     Used by home.jsp to refresh display the system clock.

     First arg of callback is the XMLHttpRequest object.  'this' will be current PageStateChecker.
     */
    this.goodResponseCallback = null;

    /**
     System state at the time the page was first loaded.
     null means unknown.
     */
    this.initialSystemState = null;

    this._initTimeMillis = new Date().getTime();
    this._totalSecOnPage = 0;

    // initialize secondsOnPage
    var params = getQueryParams(document, null);
    if (params.returning) {
        var seconds = parseInt(params.returning, 10);
        if (seconds > 0) this._totalSecOnPage = seconds;
    }

    // initialize default pollURL and reloadURL
    var path = stripURLHost(document.location);
    this.reloadURL = path;
    this.pollURL = setQueryParam(path, "ajax", "");

    /**
     * Get the number of seconds we have stayed on the same page (even across ajax refreshes).
     */
    this.getSecondsOnPage = function () {
        // Elapsed millis since last page refresh
        var nowMs = new Date().getTime();
        if (nowMs < this._initTimeMillis) {
            // rare: user reverted the clock!
            this._initTimeMillis = nowMs;
        }
        var elapsedMs = nowMs - this._initTimeMillis;

        // Plus total seconds across refreshes
        return this._totalSecOnPage + Math.floor(elapsedMs / 1000);
    };

    /**
     * Fire off another ajax request.
     */
    this.startNextCheck = function () {
        var http_request = createAjaxRequest(false);
        if (!http_request) return false;

        var self = this;
        http_request.onreadystatechange = function () {
            if (http_request.readyState == 4) {
                self.onRequestFinished(http_request);
            }
        };

        http_request.open("GET", this.pollURL);

        // safari caching workaround -
        // explicitly set to discard cached files newer than this...
        http_request.setRequestHeader(
            "If-Modified-Since",
            "Wed, 15 Nov 1995 00:00:00 GMT"
        );

        http_request.send(null);
    };

    /**
     * Called when the ajax request finishes (state 4).
     */
    this.onRequestFinished = function (http_request) {
        if (http_request.status == 200) {
            // parse the state integer out of the response
            var sLastReturn = CA_stringTrim(http_request.responseText);
            var newState = parseInt(sLastReturn, 10);

            // able to parse the number?
            if (!isNaN(newState)) {
                if (typeof this.initialSystemState != "number")
                    this.initialSystemState = newState;

                // optional.  Used by home.jsp
                if (this.goodResponseCallback) this.goodResponseCallback(http_request);

                if (this.initialSystemState != newState) {
                    // submit total seconds on page so we can keep track across page refresh.
                    var secOnPage = this.getSecondsOnPage();

                    var reloadURL = setQueryParam(this.reloadURL, "returning", secOnPage); //must use 'returning' parameter or else smart-redirection will get confused

                    if (ajaxIsBusy()) {
                        // Reload as soon as activity becomes idle
                        setInterval(function () {
                            if (!ajaxIsBusy()) {
                                document.location = reloadURL;
                            }
                        }, 1000);
                    } else {
                        document.location = reloadURL;
                    }

                    return; // no need to schedule another check
                }
            }
            // redirect to the login page - session timed out
            else {
                var oldLocation = "" + document.location;
                var newLocation = oldLocation.replace("&reload=", "");
                if (newLocation == oldLocation) {
                    document.location.reload();
                } else {
                    document.location = newLocation;
                }
                return;
            }
        }

        // Force logout after N minutes
        if (this.getSecondsOnPage() >= this.idleTimeInSecUntilUserIsLoggedOff) {
            forceLogoutFromAjaxLogoff();
            return;
        }

        /* schedule another check. */
        GlobalEnt.ajax.pollTimer = window.setTimeout(
            this.startNextCheck.bind(this),
            this.ajaxUpdateSec * 1000
        );
    };

}
